import {
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  BIG_PLAY_BUTTON
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import {
  KICKER_HINT,
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const Multimedia1: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Text':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                ...optionalFieldValues(optional, 'subtitle', KICKER_HINT),
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                ...optionalFieldValues(optional, 'title'),
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                ...optionalFieldValues(optional, 'body'),
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
        break;

      case 'Card':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'center', height: { _: 'auto', lg: '100%' } },
          items: [
            CardHelper(item as ItemOfType<'Card'>, {
              height: 'auto',
              audioPadding: '0px',
              optional: OPTIONAL_TEXT_FIELDS
            })
          ]
        });
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
